<button
    id="undo-last-drawing"
    type="button"
    class="btn-bx-secondary-stroked undo ms-2"
    [tooltip]="disabled ? 'Complete the drawing' : hasDrawings ? 'Undo the last drawing' : ''"
    placement="bottom"
    [disabled]="!hasDrawings || disabled"
    (click)="onUndo()"></button>
